/* eslint-disable @typescript-eslint/no-use-before-define */
export abstract class AbstractToken {
    public type: string;
    public static valid(token: any): boolean {
        throw new Error('valid() not implemented');
    }
    public static fromJSON(json: any): AbstractToken {
        if (Token.valid(json)) {
            return Token.fromJSON(json);
        }
        if (CSRFToken.valid(json)) {
            return CSRFToken.fromJSON(json);
        }
        throw new Error('Invalid token');
    };
}

export class Token extends AbstractToken {
    constructor(public expires: number, public token: string, public type: string = 'Token') {
        super();
    }

    public static valid(token: any): boolean {
        if (typeof token !== 'object' || token === null) {
            return false;
        }
        if (!('expires' in token) || !('token' in token)) {
            return false
        }
        if (token.expires < (+new Date() / 1000)) { // +new Date() gets current timestamp
            return false;
        }

        return true;
    }

    public static fromJSON(json: any): Token {
        if (!Token.valid(json)) {
            throw new Error('Invalid token');
        }
        return new Token(json.expires, json.token);
    }
}

export class CSRFToken extends AbstractToken {
    constructor(public name: string, public token: string, public type: string = 'CSRFToken') {
        super();
    }

    public static valid(token: any): boolean {
        if (typeof token !== 'object' || token === null) {
            return false;
        }
        if (!('name' in token) || !('token' in token)) {
            return false
        }

        if (token.name === '' || token.token === '' || token.name === null || token.token === null) {
            return false;
        }

        return true;
    }

    public static fromJSON(json: any): CSRFToken {
        if (!CSRFToken.valid(json)) {
            throw new Error('Invalid CSRF token');
        }
        return new CSRFToken(json.name, json.token);
    }
}
